// GA4 로 보낼 수 있는 한글 라벨 허용 목록 (설계 §5.4 — DOM 텍스트를 그대로 신뢰하지 않는다).
// LeftComponent.vue 의 메뉴 title 전수 (2026-09-21 기준). 메뉴 추가 시 여기도 갱신 — 누락되면 `unknown` 으로 관측된다.
export const MENU_LABELS: string[] = [
  '대쉬보드',
  '셀러 허브',
  '상품 관리',
  '상품 등록',
  '상품 리스트',
  '가격/재고 관리',
  '코디 관리',
  '쿠폰 관리',
  '스토어 진열관리',
  '연동상품관리',
  '연동상품 카테고리',
  '행사 신청하기',
  '주문 관리',
  '헬피 주문관리',
  '브랜디 주문관리',
  '취소/환불 관리',
  '배송정책 관리',
  '오늘출발 옵션 관리',
  '기획전 안내',
  '광고상품 안내',
  '정산',
  '정산예정',
  '정산 리스트',
  '정산 리스트 (공익채권)',
  '부가세 참고자료',
  '문의/답변',
  '문의 관리',
  'AI 챗봇 상담',
  '리뷰',
  '판매분석',
  '셀러 관리',
  '셀러 설정',
  '페널티 관리',
  '도매처 관리',
  '공지사항',
  '엑셀 다운로드',
  '고객센터',
  '헬피 신청안내',
  '카카오톡 문의',
  '메일 문의',
  '오류/수정 제안',
  '건의/의견 보내기',
  '채권액조회',
  '회생채권 변제계획',
  'FAQ',
  '변제금 수령계좌 조회/등록',
  '변제금 합계 (사업자단위)',
  '정산대금 (주문단위)',
  '광고선수금 (계정단위)',
  '내 스토어 바로가기',
  '셀러변경',
  '로그아웃',
  '이용 분석 수집 설정',
]

// 엑셀 다운로드 센터의 메뉴명(서버 menuName) → excel_download.type
const EXCEL_TYPE_RULES: [string, string][] = [
  ['양식', 'bulk_template'],
  ['옵션', 'option'],
  ['부가세', 'vat'],
  ['거래', 'ledger'],
  ['정산', 'payout'],
  ['취소', 'order'],
  ['환불', 'order'],
  ['주문', 'order'],
  ['상품', 'product'],
]

// 서버 menu 값은 실제로 항상 '엑셀 다운로드' 라 구분이 안 된다(2026-09-21 스테이징 확인).
// 그래서 menu 로 못 찾으면 파일명('..._전체상품목록엑셀다운로드_...')으로 분류한다. 파일명 자체는 전송하지 않는다.
export function excelTypeOf(menuName: string | undefined | null, fileName?: string | null): string {
  const candidates = [String(menuName || ''), String(fileName || '')]
  for (const name of candidates) {
    const hit = EXCEL_TYPE_RULES.find(([keyword]) => name.indexOf(keyword) >= 0)
    if (hit) return hit[1]
  }
  return 'unknown'
}
